import React from "react";
import FooterComponent from "./../../Generic/Footer/FooterComponent";
import HeaderComponent from "./../../Generic/Header/HeaderComponent";
import SeoMeta from "./../../Generic/SEO/SeoMeta";
import ProductListing from "../Catalog/ProductListing";
import { getCategoryMeta } from "../Catalog/categoryMeta";
import * as endpoint from "./../../../Service/endpoints";

function CategoryComponent({ match }) {
  const category = match.params.category;
  const citySlug = match.params.city || "delhi";
  const cityName = citySlug.charAt(0).toUpperCase() + citySlug.slice(1);
  const meta = getCategoryMeta(category);

  return (
    <React.Fragment>
      <SeoMeta
        title={`${meta.short} on Rent in ${cityName} | Voorent`}
        description={`Browse ${meta.short.toLowerCase()} on rent in ${cityName}. ${meta.description}`}
        canonical={`https://voorent.com/${citySlug}/${category}`}
        image={meta.image || "https://voorent.com/logo192.png"}
      />
      <HeaderComponent />
      <ProductListing
        mode="category"
        category={category}
        heading={meta.title}
        description={meta.description}
        crumbs={[
          { label: "Home", to: endpoint.getPath("") },
          { label: meta.short, to: endpoint.getPath(category) },
        ]}
      />
      <FooterComponent />
    </React.Fragment>
  );
}

export default CategoryComponent;
